import { CSS, styled } from '../../../theme/stitches.config';

// css={{ $$progressWidth: `${value}%` }}
// const widthUp = keyframes({
//   '0%': { width: '0' },
//   '100%': { width: '$$progressWidth' },
// });

const ProgressBar = styled('div', {
  bc: '$progressBarPrimaryBgColor',
  borderRadius: '$1',
});

const ProgressBarContent = styled('div', {
  backgroundColor: 'orange',
  height: '$1',
  borderRadius: '$1',
  // animation: `${widthUp} 1s`,
});

type SMPProgressBarProps = {
  value?: string | number;
  css?: CSS;
};

export const SMPProgressBar = ({ value, css }: SMPProgressBarProps) => {
  return (
    <ProgressBar css={css}>
      <ProgressBarContent style={{ width: `${value}%` }} />
    </ProgressBar>
  );
};
